<div class="row" *ngIf="!loading">
  <div class="ir-area ir-mask th-mask">
    <form class="ir-modal th-modal" (ngSubmit)="save()" [formGroup]="editForm">
      <div class="ir-modal--title">
        <div class="ir-line--right">
          <div class="ir-btn th-btn-modal" (click)="openMenu()">
            <i class="material-icons">more_vert</i>
          </div>
        </div>
      </div>
      <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
        <div class="ir-content--modal th-content th-content-customer">
          <h2>
            <span>{{ people.length }} {{ 'people.user-count-edited' | translate }}</span>
          </h2>
          <table class="ir-modal-table">
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.language' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  (click)="editForm.controls.updateLanguage.value = !editForm.controls.updateLanguage.value"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!editForm.controls.updateLanguage.value"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="editForm.controls.updateLanguage.value">check_box</i>
                    </div>
                  </div>
                </div>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <select name="language" class="ir-form-set" formControlName="language">
                    <option *ngFor="let language of languages | orderBy : 'name'" [value]="language.value">
                      {{ language.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr class="th-plugin-line--input">
              <td style="width: 25%">
                <span>{{ 'people.applications' | translate }}</span>
              </td>
              <td class="th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  (click)="editForm.controls.updateApplications.value = !editForm.controls.updateApplications.value"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!editForm.controls.updateApplications.value"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="editForm.controls.updateApplications.value">check_box</i>
                    </div>
                  </div>
                </div>
              </td>
              <td class="margin-big th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  *ngFor="let applicationType of applicationTypes; let last = last"
                  (click)="updateApplicationTypes(applicationType.Value)"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!isInPersonApplicationTypes(applicationType.Value)"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="isInPersonApplicationTypes(applicationType.Value)">check_box</i>
                    </div>
                    <span>{{ applicationType.Label | translate }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big" style="width: 25%">
                <span>{{ 'people.profiles' | translate }}</span>
              </td>
              <td class="margin-big th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  (click)="editForm.controls.updateProfiles.value = !editForm.controls.updateProfiles.value"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!editForm.controls.updateProfiles.value"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="editForm.controls.updateProfiles.value">check_box</i>
                    </div>
                  </div>
                </div>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select" (click)="openPermissionsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big" style="width: 25%">
                <span>{{ 'people.localEntities' | translate }}</span>
              </td>
              <td class="margin-big th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  (click)="editForm.controls.updateLocalEntities.value = !editForm.controls.updateLocalEntities.value"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!editForm.controls.updateLocalEntities.value"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="editForm.controls.updateLocalEntities.value">check_box</i>
                    </div>
                  </div>
                </div>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select" (click)="openLocalEntitiesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedLocalEntitiesValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td style="width: 25%">
                <span>{{ 'plugins.equipment-info.product-line' | translate }}</span>
              </td>
              <td class="th-plugin-line--value">
                <div
                  class="ir-item-line clickable indent nobreak"
                  (click)="editForm.controls.updateProductLine.value = !editForm.controls.updateProductLine.value"
                >
                  <div class="ir-item-cell">
                    <div class="ir-item-selector">
                      <i class="material-icons" *ngIf="!editForm.controls.updateProductLine.value"
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons" *ngIf="editForm.controls.updateProductLine.value">check_box</i>
                    </div>
                  </div>
                </div>
              </td>
              <td class="th-plugin-line--value">
                <div class="ir-line ir-select th-select" (click)="openProductLinesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedProductLineValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-modal--footer ir-position--b th-modal--footer">
        <div class="ir-row">
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
              <span>{{ 'common.cancel' | translate }}</span>
            </div>
          </div>
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
              type="submit"
              [disabled]="editForm.invalid"
              *ngIf="!processing"
            >
              <span>{{ 'common.save-changes' | translate }}</span>
            </button>
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
              type="submit"
              *ngIf="processing"
            >
              <span>{{ 'common.processing' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal #permissionsModal (modalClosed)="onPermissionsMenuClose()"></modal>
<modal #productLinesModal (modalClosed)="onProductLinesMenuClose()"></modal>
<modal #localEntitiesModal (modalClosed)="onLocalEntitiesMenuClose()"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePeople()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'people.sure-to-delete' | translate"
  [danger]="true"
></confirm>
